import React from 'react';
import { FilterBand } from './FilterBand';
import { HookSection } from './HookSection';
import { PainSection } from './PainSection';
import { RevelationSection } from './RevelationSection';
import { ProofSection } from './ProofSection';
import { OfferSection } from './OfferSection';
import { ObjectionsSection } from './ObjectionsSection';
import { GuaranteeSection } from './GuaranteeSection';
import { CloseSection } from './CloseSection';
import { SiteFooter } from './SiteFooter';
import { LiveViewersBadge } from './LiveViewersBadge';
import { SaleNotification } from './SaleNotification';
export function BelowFold() {
  return <>
      <FilterBand data-id="element-7" data-mp="igt4oywdruio" />
      <HookSection data-id="element-8" data-mp="ihcqiqp5j31z" />
      <PainSection data-id="element-9" data-mp="dojhvrqkbakm" />
      <RevelationSection data-id="element-10" data-mp="do9tg8l61bh1" />
      <ProofSection data-id="element-11" data-mp="dnrrcvbto317" />
      <OfferSection data-id="element-12" data-mp="dmgl8ouwmj6x" />
      <ObjectionsSection data-id="element-13" data-mp="3m4d0cc4gew4b" />
      <GuaranteeSection data-id="element-14" data-mp="3m3js16pujyk2" />
      <CloseSection data-id="element-15" data-mp="3m31vsa36pkc5" />
      <SiteFooter data-id="element-16" data-mp="3m28on80bcsth" />
      <LiveViewersBadge data-id="element-17" data-mp="3h59wgv07mvxx" />
      <SaleNotification data-id="element-18" data-mp="3h61s25tt4to7" />
    </>;
}